import Footer from '../Layouts/Footer';
import Header from '../Layouts/Header';
import FTRewards from '../Components/FTRewards';
import BBRewards from '../Components/BBRewards';
import DailyRewards from '../Components/DailyRewards';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useState } from "react";
import ProgressBarComponent from '../Components/ProgressBarComponent';
function Home() {
	const [loading, setLoading] = useState(false);
	const [loadingMessage, setLoadingMessage] = useState("Loading ...");
	const [isClaimSuccessFul, setIsClaimSuccessful] = useState(false);
	const [isAssociationSuccessFul, setIsAssociationSuccessful] = useState(false);

	async function closeSuccessModal() {
        setIsAssociationSuccessful(false)
        setIsClaimSuccessful(false)
    }
	
	return (
		<>
			<Header></Header>
			{(isClaimSuccessFul) ?
				<div id="connectWindowContainer" className="connectWindowContainer">
					<div className="connectWindow">
						<span className='notification-icon'>
							<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g fill="none" stroke="green" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="m24 4l5.253 3.832l6.503-.012l1.997 6.188l5.268 3.812L41 24l2.021 6.18l-5.268 3.812l-1.997 6.188l-6.503-.012L24 44l-5.253-3.832l-6.503.012l-1.997-6.188l-5.268-3.812L7 24l-2.021-6.18l5.268-3.812l1.997-6.188l6.503.012L24 4Z" /><path d="m17 24l5 5l10-10" /></g></svg>
						</span>
						<span className='notification-text qr'>Request successfully sent. <br></br> You will receive the airdrop in a few minutes.</span>

						<span className="btnWallets ok" onClick={() => closeSuccessModal()}>OK</span>
						<div className="rantCPU_04"></div>
					</div>
				</div>
				:
				<></>
			}
			{(isAssociationSuccessFul) ?
				<div id="connectWindowContainer" className="connectWindowContainer">
					<div className="connectWindow">
						<span className='notification-icon'>
							<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g fill="none" stroke="green" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="m24 4l5.253 3.832l6.503-.012l1.997 6.188l5.268 3.812L41 24l2.021 6.18l-5.268 3.812l-1.997 6.188l-6.503-.012L24 44l-5.253-3.832l-6.503.012l-1.997-6.188l-5.268-3.812L7 24l-2.021-6.18l5.268-3.812l1.997-6.188l6.503.012L24 4Z" /><path d="m17 24l5 5l10-10" /></g></svg>
						</span>
						<span className='notification-text qr'>Tokens successfully associated.</span>

						<span className="btnWallets ok" onClick={() => closeSuccessModal()}>OK</span>
						<div className="rantCPU_04"></div>
					</div>
				</div>
				:
				<></>
			}

			<div className="mainDiv">
				<div className="rewardsContainer">
					<FTRewards setLoading={setLoading} setIsClaimSuccessful={setIsClaimSuccessful} setIsAssociationSuccessful={setIsAssociationSuccessful} />
					<BBRewards setLoading={setLoading} setIsClaimSuccessful={setIsClaimSuccessful} setIsAssociationSuccessful={setIsAssociationSuccessful} />
					<DailyRewards setLoading={setLoading} setLoadingMessage={setLoadingMessage} isAssociationSuccessFul={isAssociationSuccessFul} setIsAssociationSuccessful={setIsAssociationSuccessful} />
				</div>
				<div className="rantCPU_02"></div>
			</div>
			<Footer></Footer>
			{(loading === true) ?
				<ProgressBarComponent loadingMessage={loadingMessage} />
				:
				<></>
			}
		</>
	);
}

export default Home;